import 'babel-polyfill';

import Vue from 'vue';

import Slick from 'vue-slick';
//https://vuejsfeed.com/blog/implementing-slick-carousel-using-the-vue-slick-component-for-vue-js

import VueSilentbox from 'vue-silentbox'
Vue.use(VueSilentbox)

import svg_icons from './common/svg_icons.vue';

// SASS/CSS
import '../../css/sass/public.scss';

// images
import '../../images/icons-public.svg';

// disable the warning about dev/prod
Vue.config.productionTip = false;

new Vue({
    el: '#app',
    components: {
        'svg-icons': svg_icons,
        Slick,
    },
    data: {
        show: false,
        scroll: false,
        slickOptions: {
            slidesToShow: 1,
            infinite: true,
            swipe: true,
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            pauseOnHover: false,
            zindex: 1,
            // lazyload: progressive,
            // Any other options that can be got from plugin documentation
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.windowResize);
        });
    },

    methods: {
        toggle(e) {
           this.show = !this.show
           e.preventDefault();
        },
        windowResize() {
            this.show = false;
        },
    },


});


// WEBPACK FOOTER //
// ./html/js/src/public.js